import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { memo, useCallback } from 'react';
import { jsx } from '@emotion/core';
import { PrismAsync as SyntaxHighlighter } from 'react-syntax-highlighter';
import { normalizeLanguage } from '../supportedLanguages';
import { applyTheme } from '../themes/themeBuilder';
import { useHighlightLines } from './hooks/use-highlight';

var CodeBlock = function CodeBlock(_ref) {
  var _ref$showLineNumbers = _ref.showLineNumbers,
      showLineNumbers = _ref$showLineNumbers === void 0 ? true : _ref$showLineNumbers,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'text' : _ref$language,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      _ref$themeOverride = _ref.themeOverride,
      themeOverride = _ref$themeOverride === void 0 ? {} : _ref$themeOverride,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? '' : _ref$highlight,
      _ref$highlightedStart = _ref.highlightedStartText,
      highlightedStartText = _ref$highlightedStart === void 0 ? 'Highlight start' : _ref$highlightedStart,
      _ref$highlightedEndTe = _ref.highlightedEndText,
      highlightedEndText = _ref$highlightedEndTe === void 0 ? 'Highlight end' : _ref$highlightedEndTe,
      testId = _ref.testId,
      text = _ref.text;
  // TODO look at memoising this
  var numLines = (text || '').split('\n').length;

  var _applyTheme = applyTheme(_objectSpread(_objectSpread({}, theme), themeOverride), numLines),
      lineNumberStyle = _applyTheme.lineNumberStyle,
      codeBlockStyle = _applyTheme.codeBlockStyle,
      codeContainerStyle = _applyTheme.codeContainerStyle,
      codeLayoutContainer = _applyTheme.codeLayoutContainer;

  var _useHighlightLines = useHighlightLines({
    highlight: highlight,
    testId: testId
  }),
      getHighlightStyles = _useHighlightLines.getHighlightStyles,
      highlightedLines = _useHighlightLines.highlightedLines;

  var getLineProps = useCallback(function (line) {
    return getHighlightStyles(line, highlightedLines);
  }, [getHighlightStyles, highlightedLines]);
  var props = {
    language: normalizeLanguage(language),
    PreTag: 'span',
    style: codeBlockStyle,
    lineNumberStyle: lineNumberStyle,
    showLineNumbers: showLineNumbers,
    codeTagProps: {
      style: codeContainerStyle(showLineNumbers)
    },
    // Wrap lines is needed to set styles on the line when highlighting.
    wrapLines: highlight.length > 0 || testId,
    lineProps: getLineProps
  };
  return jsx("div", {
    "data-testid": testId,
    "data-code-block": "",
    css: codeLayoutContainer(highlightedStartText, highlightedEndText, showLineNumbers)
  }, jsx(SyntaxHighlighter, _extends({
    "data-code-lang": language
  }, props), text));
};

export default /*#__PURE__*/memo(CodeBlock);